<div class="container">
  <div class="row">
    <div class="main-content col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
      <app-unauth-survey *ngIf="!USER"></app-unauth-survey>
    </div>
  </div>
</div>
